import { useGetApiData } from "shared/datalayer";
import PublicApi from "shared/enums/PublicApi";
import { getErrorMessage } from "shared/utils/network";
import { errorToast } from "shared/utils/toastNotification";
import { StaticDataQueryParams, StaticDataResponseObject } from "./staticData";

export function useGetStaticData({ regKey }: StaticDataQueryParams) {
  return useGetApiData<StaticDataResponseObject>(
    PublicApi.STATIC_DATA,
    { params: { regKey } },
    { onError: err => errorToast(getErrorMessage(err)) }
  );
}
